var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 140,
    viewBox: "0 0 201 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.966 53.2989C52.6161 50.3604 48.8093 48.8913 43.5498 48.8913C35.6071 48.8913 28.5119 52.4141 22.269 59.4637L29.2735 64.5422C31.0347 62.5666 32.8211 61.0524 34.6356 59.9946C36.4509 58.9372 38.5127 58.4059 40.813 58.4059C43.0229 58.4059 44.6238 58.9946 45.6197 60.1716C46.6157 61.3445 46.8378 62.9454 46.2906 64.9621C45.7145 67.0772 44.7145 68.8429 43.2987 70.2501C41.8789 71.6619 39.7226 73.2835 36.8252 75.1147L15.7914 88.93L13.3511 97.8853H47.6116L50.0522 88.93H30.5945L40.6401 82.5882C45.4224 79.5345 49.0355 76.6663 51.4802 73.9869C53.9245 71.3079 55.6531 68.1143 56.6657 64.3982C57.8797 59.9372 57.3159 56.233 54.966 53.2989Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1237 79.3443H65.5634L81.4654 63.4138L77.1237 79.3443ZM95.6306 49.4544H83.7864L54.2131 79.3443L51.7355 88.4354H74.6464L73.214 93.7031C74.9426 93.5262 76.7245 93.4314 78.5557 93.4314C80.2347 93.4314 81.9138 93.5136 83.5806 93.6865L85.0086 88.4354H89.7331L92.2107 79.3443H87.4862L95.6306 49.4544Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.619 39.5895L91.2804 95.0818C93.6425 95.7072 96.7784 96.7031 99.791 98.1763L130.768 39.5895H120.619Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.142 49.6651L125.471 59.4637H148.172L119.022 97.8853H130.373L159.102 59.1838L161.695 49.6651H128.142Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0191 135.491V121.183H15.4911V116.403H38.328V121.183H29.8285V135.491H24.0191Z",
    fill: "#FECB00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4258 128.079H58.7516L54.6261 120.064L50.4258 128.079ZM46.4854 135.491H40.0796L50.7194 116.403H58.561L68.9727 135.491H62.5821L60.785 132.028H48.3565L46.4854 135.491Z",
    fill: "#FECB00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3689 135.491H91.4092L84.9675 129.404L78.5647 135.491H70.6657L81.1104 125.761L71.2092 116.403H78.9601L85.0801 122.126L91.1982 116.403H98.6825L88.9013 125.701L99.3689 135.491Z",
    fill: "#FECB00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_309_2280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 140
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.792218H200.249V140H0V0.792218Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_309_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.631 116.403H108.44V135.491H102.631V116.403Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.153 63.9767C195.149 65.4539 195.009 66.9397 194.787 68.3965C194.507 70.1992 194.133 71.9893 193.696 73.759C193.347 75.1622 192.861 76.5369 192.404 77.9116C191.943 79.2944 191.548 80.7057 190.943 82.0227C189.956 84.1671 188.91 86.2904 187.725 88.3274C186.601 90.2619 185.363 92.1382 184 93.908C182.646 95.6736 181.161 97.3567 179.585 98.9287C177.836 100.674 175.963 102.308 174.066 103.896C171.465 106.073 168.584 107.864 165.555 109.361C163.16 110.543 160.658 111.51 158.16 112.464C156.723 113.016 155.217 113.407 153.715 113.765C152.081 114.152 150.419 114.44 148.76 114.732C147.163 115.012 145.562 115.234 143.892 115.493C144.9 118.958 146.476 122.238 147.303 125.745C147.213 125.815 147.122 125.881 147.036 125.946C146.698 125.794 146.311 125.708 146.032 125.485C144.311 124.127 142.636 122.716 140.916 121.358C138.739 119.646 136.521 117.983 134.34 116.271C132.677 114.967 131.023 113.654 129.414 112.288C128.409 111.431 128.508 110.777 129.574 109.987C131.508 108.555 133.414 107.094 135.34 105.653C136.887 104.493 138.447 103.353 139.995 102.201C141.492 101.085 142.982 99.9576 144.476 98.8384C145.192 98.3075 145.908 97.7762 146.612 97.2538C147.13 97.5874 147.13 97.9987 146.941 98.4882C146.287 100.196 145.661 101.912 145.003 103.62C144.731 104.32 144.41 104.999 144.118 105.69C144.056 105.838 144.032 106.007 143.953 106.304C144.657 106.312 145.295 106.39 145.908 106.308C147.18 106.143 148.447 105.933 149.702 105.661C151.044 105.369 152.394 105.044 153.698 104.616C155.386 104.065 157.057 103.452 158.691 102.76C161.353 101.637 163.831 100.184 166.238 98.5789C168.806 96.8669 171.177 94.9243 173.259 92.6855C175.095 90.7106 176.799 88.5951 178.383 86.4137C179.56 84.788 180.56 83.0105 181.457 81.2082C182.329 79.4547 183.005 77.5984 183.704 75.7672C184.202 74.4665 184.634 73.1333 185.021 71.796C185.227 71.0841 185.276 70.3225 185.412 69.5902C185.626 68.4458 185.869 67.3062 186.066 66.1577C186.144 65.7009 186.165 65.2277 186.169 64.7586C186.19 62.0714 186.26 59.3839 186.185 56.6964C186.153 55.499 185.812 54.3094 185.613 53.1121C185.506 52.4697 185.404 51.8281 185.297 51.1861C184.906 48.8814 184.255 46.6548 183.329 44.5067C182.535 42.663 181.922 40.7122 180.926 38.9876C179.506 36.5311 177.951 34.1194 176.185 31.9009C174.56 29.8517 172.691 27.9587 170.728 26.226C168.806 24.5307 166.674 23.0571 164.555 21.6084C162.25 20.0364 159.744 18.8142 157.102 17.9005C155.073 17.1967 153.032 16.5177 150.979 15.8923C150.193 15.6535 149.349 15.5958 148.534 15.4558C147.163 15.2256 145.797 14.9619 144.423 14.7727C143.719 14.678 142.999 14.6987 142.283 14.6906C140.879 14.6739 139.468 14.5917 138.068 14.6906C136.566 14.7976 135.076 15.0775 133.579 15.2874C132.891 15.3818 132.2 15.4518 131.525 15.5999C129.57 16.0278 127.591 16.3777 125.689 16.9705C123.664 17.6002 121.665 18.3529 119.755 19.2667C117.524 20.3326 115.343 21.5303 113.252 22.8472C109.306 25.337 105.811 28.3867 102.688 31.8598C100.486 34.3086 98.5933 36.9921 96.9513 39.8355C95.9387 41.593 95.1076 43.4656 94.3134 45.3379H87.7943C88.2019 43.8359 88.6669 42.3501 89.2019 40.8932C89.8232 39.2061 90.6999 37.6092 91.4656 35.9795C92.7988 33.1438 94.4448 30.4855 96.3464 28.0079C97.6507 26.3 99.042 24.6414 100.511 23.0734C101.919 21.5632 103.396 20.0982 104.989 18.7935C106.89 17.2337 108.874 15.7479 110.956 14.4517C113.405 12.933 115.948 11.5461 118.549 10.3077C120.409 9.42284 122.417 8.83824 124.389 8.19218C125.85 7.71495 127.348 7.34435 128.837 6.95783C129.418 6.80529 130.019 6.70643 130.615 6.62424C131.85 6.45542 133.089 6.30324 134.327 6.15922C135.106 6.06851 135.883 5.98632 136.665 5.93708C138.274 5.8423 139.891 5.65311 141.492 5.72308C143.612 5.82156 145.723 6.1222 147.838 6.36101C148.978 6.48837 150.118 6.61202 151.242 6.83416C152.419 7.06852 153.575 7.4147 154.74 7.72718C155.67 7.97819 156.617 8.20885 157.522 8.53799C159.25 9.16739 161.004 9.76013 162.658 10.5587C165.181 11.7727 167.695 13.036 170.091 14.4847C171.868 15.5547 173.543 16.8427 175.099 18.2215C177.465 20.3204 179.807 22.4685 181.939 24.8061C183.91 26.9668 185.651 29.3537 187.091 31.9258C188.161 33.8395 189.31 35.7159 190.248 37.6914C191.062 39.416 191.663 41.2431 192.305 43.0458C192.791 44.3957 193.207 45.774 193.614 47.1487C193.791 47.7455 193.865 48.3709 193.984 48.984C194.297 50.6056 194.647 52.2228 194.902 53.8526C195.026 54.6264 194.956 55.429 194.976 56.215C195.042 58.8034 195.166 61.388 195.153 63.9767Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51 24.9019H140.209C139.461 24.9019 138.856 24.2965 138.856 23.5498V17.6897C138.856 16.9429 139.461 16.3376 140.209 16.3376H140.51C141.257 16.3376 141.862 16.9429 141.862 17.6897V23.5498C141.862 24.2965 141.257 24.9019 140.51 24.9019Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.772 26.6321L127.488 26.7324C126.784 26.9812 126.011 26.6121 125.763 25.9079L123.811 20.3825C123.562 19.6783 123.931 18.906 124.635 18.6572L124.92 18.5565C125.624 18.3081 126.396 18.6772 126.645 19.3814L128.597 24.9068C128.846 25.611 128.476 26.3833 127.772 26.6321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.432 32.8726L116.197 33.0622C115.616 33.5313 114.765 33.4406 114.296 32.8593L110.615 28.2999C110.146 27.7186 110.236 26.8674 110.818 26.3983L111.052 26.2088C111.633 25.7397 112.485 25.8304 112.954 26.4117L116.635 30.9711C117.104 31.5524 117.013 32.4035 116.432 32.8726Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.554 41.9427L107.395 42.1996C107.004 42.8353 106.171 43.0334 105.535 42.6417L100.545 39.5684C99.9096 39.177 99.7115 38.344 100.103 37.7079L100.262 37.4514C100.653 36.8153 101.486 36.6176 102.122 37.0089L107.112 40.0823C107.747 40.474 107.946 41.307 107.554 41.9427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.723 27.7825L154.442 27.6733C153.746 27.4023 153.402 26.6181 153.673 25.9224L155.799 20.4618C156.07 19.7658 156.853 19.4215 157.549 19.6921L157.831 19.8017C158.526 20.0727 158.871 20.8561 158.6 21.5522L156.474 27.0131C156.203 27.7088 155.419 28.0535 154.723 27.7825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.923 35.6244L166.7 35.4204C166.15 34.9154 166.113 34.0602 166.619 33.51L170.581 29.1927C171.086 28.6425 171.942 28.6059 172.492 29.1109L172.714 29.3149C173.264 29.8199 173.301 30.6751 172.796 31.2253L168.833 35.5426C168.328 36.0928 167.473 36.1294 166.923 35.6244Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.518 47.814L174.385 47.5433C174.056 46.8728 174.332 46.0628 175.002 45.7332L180.261 43.1475C180.931 42.818 181.742 43.0942 182.071 43.7643L182.204 44.0353C182.534 44.7055 182.257 45.5156 181.588 45.8454L176.329 48.4308C175.658 48.7603 174.848 48.4841 174.518 47.814Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.44 61.6158L176.414 61.3151C176.35 60.5713 176.901 59.9164 177.645 59.8523L183.484 59.351C184.228 59.287 184.883 59.8386 184.947 60.5824L184.973 60.8831C185.037 61.6272 184.485 62.2822 183.741 62.3459L177.903 62.8475C177.159 62.9112 176.504 62.3599 176.44 61.6158Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.768 74.8126L173.853 74.5231C174.063 73.8067 174.815 73.3961 175.531 73.6068L181.154 75.258C181.87 75.4683 182.281 76.2195 182.07 76.9363L181.985 77.2258C181.775 77.9422 181.024 78.3525 180.307 78.1422L174.685 76.4909C173.968 76.2806 173.558 75.5291 173.768 74.8126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.224 85.1596L166.408 84.9208C166.864 84.3296 167.713 84.22 168.305 84.6757L172.945 88.2544C173.537 88.7106 173.646 89.5595 173.19 90.1508L173.006 90.3899C172.55 90.9812 171.701 91.0912 171.11 90.635L166.469 87.0564C165.878 86.6002 165.769 85.7513 166.224 85.1596Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.491 92.7137L156.749 92.5582C157.389 92.1724 158.22 92.3782 158.605 93.0176L161.631 98.0362C162.017 98.676 161.811 99.5068 161.172 99.8925L160.913 100.048C160.274 100.434 159.443 100.228 159.057 99.5882L156.031 94.57C155.645 93.9303 155.851 93.0995 156.491 92.7137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32199 129.112C5.32199 129.112 1.91434 111.185 21.4713 108.353C34.1804 107.233 56.4371 108.518 70.7592 109.209C85.0814 109.9 93.4769 108.591 96.1441 107.912C96.1441 107.912 88.4398 112.744 48.634 111.52C8.82849 110.296 8.43345 115.827 5.32199 129.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6913 105.654C46.6913 105.654 64.6022 92.221 87.0566 96.2373C87.0566 96.2373 95.716 97.686 101.872 101.703C108.029 105.72 117.116 106.411 122.714 106.049C128.311 105.687 127.949 106.279 127.257 107.662C126.566 109.045 125.287 112.338 127.639 115.696C129.99 119.054 128.382 126.232 127.639 127.483H118.434C118.434 127.483 118.318 115.432 105.922 114.346C105.922 114.346 111.898 113.605 116.689 116.47L124.838 116.338C124.838 116.338 122.236 113.836 122.928 110.049C122.928 110.049 115.207 107.728 108.046 109.308C100.885 110.889 92.489 115.729 63.2031 114.05C63.2031 114.05 90.2832 113.753 103.519 105.72C103.519 105.72 86.4309 91.0355 46.6913 105.654Z",
    fill: "#FECB00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.59d57d99028ac5e247f9d4443023e4d8.svg";
export { ForwardRef as ReactComponent };